// import React from "react";
import { ReactNode, useEffect, useState } from "react";
import {
  additionalMenuItems,
  adminMenuItems,
  // additionalMenuItems,
} from "../../Pages/Utils/common";
import projectLogo from "../../assets/forsatak-sidebar-logo.svg";
import {
  AppBar,
  Box,
  CssBaseline,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./Sidenav.css";

import { Link as RouterLink } from "react-router-dom";
import CustomModal from "../CustomModel/CustomModel";
import CustomDrawer from "../CustomDrawer";
// import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { useSnackbar } from "../../context/SnackbarContext";
import axios from "axios";
import { getProfile, refreshToken } from "../../api/profile";
import {
  useCompanyData,
  useCreatedJobData,
} from "../../context/MasterContextProvider";
// import { useSnackbar } from "../../context/SnackbarContext";

interface Props {
  window?: () => Window;
  mobileOpen?: boolean;
  onMobileToggle?: () => void;
}

const Sidenav = (props: Props) => {
  const [internalMobileOpen, setInternalMobileOpen] = useState<boolean>(false);
  const mobileOpen =
    props.mobileOpen !== undefined ? props.mobileOpen : internalMobileOpen;
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  const [selectedComponent, setSelectedComponent] = useState<ReactNode | null>(
    null
  );
  const [selectedNavName, SetSelectedNavName] = useState<string>("");
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [, setData] = useState<any>(null);
  const [, setLoading] = useState<boolean>(true);
  const navigate = useNavigate();
  const location = useLocation();
  const { window } = props;
  const drawerWidth = 240;
  const { showSnackbar } = useSnackbar();

  const [, setSelectedRoute] = useState("/dashboard");

  const handleSelectedRoute = (route: string) => {
    setSelectedRoute(route);
  };

  const { setCreatedJob } = useCreatedJobData();

  const getMe = async () => {
    const profile = await getProfile();
    if (profile) {
      setCreatedJob((prevState) => prevState + 1);
      // document.location.reload();
    } else {
      navigate("/login");
    }
  };

  const refresh = async () => {
    localStorage.removeItem("userId");
    const resp = await refreshToken();
    if (resp.data.id) {
      localStorage.setItem("userId", resp.data.id);
      getMe();
    } else {
      navigate("/login");
    }
  };

  useEffect(() => {
    const apiUrl = `${import.meta.env.VITE_BASE_URL}/clients/user/me`;
    const currentToken = localStorage.getItem("userId");

    if (
      !currentToken ||
      currentToken === "undefined" ||
      currentToken === "null"
    ) {
      if (currentToken === "undefined" || currentToken === "null") {
        navigate("/login");
        showSnackbar("Incorrect Username and Password", "error");
      }
      setLoading(false);
      return;
    }

    const headers = {
      Authorization: currentToken,
    };

    axios
      .get(apiUrl, { headers })
      .then((response) => {
        if (response.data) {
          setData(response.data);
          const region = {
            countryName: response.data.data.meta.countryName,
            countryId: response.data.data.meta.countryId,
          };
          localStorage.setItem("firstname", response.data.data.meta.firstname);
          localStorage.setItem("lastname", response.data.data.meta.lastname);
          localStorage.setItem("email", response.data.data.meta.email);
          localStorage.setItem("companyId", response.data.data.meta.companyId);
          localStorage.setItem("region", JSON.stringify(region));
        } else {
          refresh();
          navigate("/login");
        }
        setLoading(false);
      })
      .catch((error) => {
        // Only remove userId and redirect on authentication errors (401, 403)
        // Don't remove on network errors or other issues
        const status = error.response?.status;
        if (status === 401 || status === 403) {
          refresh();
          navigate("/login");
        } else {
          console.error("Error fetching data:", error);
        }
        setLoading(false);
      });
    // Fetch /me once per mount. navigate/showSnackbar/setCreatedJob are used inside
    // but listing them re-runs this on every snackbar render (showSnackbar isn't
    // memoized), re-firing /me on navigation. Run once instead.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isSelectedPath = (Link: string) => {
    // Check exact path match first
    if (location.pathname === Link) {
      return true;
    }

    // Special case: If on JobApplicationsView page, highlight "Jobs & Applications" menu
    if (
      Link === "/dashboard/jobsposted" &&
      location.pathname.match(/^\/dashboard\/jobs\/[^/]+\/applications$/)
    ) {
      return true;
    }

    return false;
  };

  const handleSelection = (
    component: React.Component,
    name: string,
    isDrawer: boolean,
    route: string
  ) => {
    if (name === "Logout") {
      setModalOpen(true);
      return false;
    }
    if (isDrawer) {
      setDrawerOpen(true);
      SetSelectedNavName(name);
      setSelectedComponent(<>{component}</>);
    }
    handleSelectedRoute(route);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleDrawerToggle = () => {
    if (props.onMobileToggle) {
      props.onMobileToggle();
    } else {
      setInternalMobileOpen(!internalMobileOpen);
    }
  };

  const onLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  const { company } = useCompanyData();

  const drawer = (
    <aside className="sidebar-box">
      <div>
        <div className="menu">
          <div className="mobile-menu-header">
            <h1 className="menu1">Menu</h1>
            <IconButton
              className="mobile-menu-close"
              onClick={handleDrawerToggle}
              sx={{ display: { xs: "block", sm: "none" } }}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <img src={projectLogo} alt="logo" className="sidebar-logo" />
        </div>
        <List>
          {adminMenuItems.map((menuItem: any, index) => (
            <RouterLink to={menuItem.Link} key={index} className="context">
              <ListItem
                onClick={() =>
                  handleSelection(
                    //@ts-ignore
                    menuItem?.component,
                    menuItem.Name,
                    menuItem?.isDrawer,
                    menuItem.Link
                  )
                }
                key={menuItem.Name}
                disablePadding
                className={
                  isSelectedPath(menuItem.Link)
                    ? "list-item-selected"
                    : "list-item"
                }
              >
                <ListItemButton className="list_item_btn">
                  <img
                    src={
                      isSelectedPath(menuItem.Link)
                        ? menuItem.activeIcon
                        : menuItem.Icon
                    }
                    alt={menuItem.Name}
                    style={{
                      width: "24px",
                      height: "24px",
                      // minWidth: "45px",
                    }}
                  />
                  <ListItemText
                    primary={menuItem.Name}
                    primaryTypographyProps={{
                      variant: "body2",
                      style: {
                        fontSize: "16px",
                      },
                    }}
                  />
                  {menuItem.Name === "Placements" && (
                    <div className="red_badge_stat">
                      {company?.dashboardInfo?.placements || 0}
                    </div>
                  )}
                </ListItemButton>
              </ListItem>
            </RouterLink>
          ))}
        </List>
      </div>
      <List>
        {additionalMenuItems.map((menuItem: any, index) => (
          <RouterLink to={menuItem.Link} key={index} className="context">
            <ListItem
              key={menuItem.Name}
              disablePadding
              onClick={() =>
                handleSelection(
                  //@ts-ignore
                  menuItem?.component,
                  menuItem.Name,
                  menuItem?.isDrawer,
                  menuItem.Link
                )
              }
              className={
                isSelectedPath(menuItem.Link)
                  ? "list-item-selected"
                  : "list-item"
              }
            >
              <ListItemButton className="list_item_btn">
                <img
                  src={
                    isSelectedPath(menuItem.Link)
                      ? menuItem.activeIcon
                      : menuItem.Icon
                  }
                  alt={menuItem.Name}
                  style={{
                    width: "24px",
                    height: "24px",
                    // minWidth: "45px",
                  }}
                />
                <ListItemText
                  primary={menuItem.Name}
                  primaryTypographyProps={{
                    variant: "body2",
                    style: {
                      fontSize: "16px",
                    },
                  }}
                />
              </ListItemButton>
            </ListItem>
          </RouterLink>
        ))}
      </List>
      {/* Mobile Create Job Button */}
      <div className="mobile-create-job-container">
        <button
          className="mobile-create-job-btn"
          onClick={() => {
            navigate("/createjob");
            handleDrawerToggle();
          }}
        >
          Create Job
        </button>
      </div>
    </aside>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;
  return (
    <div>
      <CustomDrawer
        onClose={handleDrawerClose}
        open={drawerOpen}
        children={selectedComponent}
        title={selectedNavName}
      />

      <CustomModal
        body="Do you want to logout"
        message="Are you sure?"
        primaryBtnLabel="Yes"
        secondaryBtnLabel="No"
        onPrimary={onLogout}
        open={modalOpen}
        onSecondary={() => setModalOpen(false)}
        hideSecondaryBtn={false}
        modalStyle={{ backgroundColor: "white" }}
        modalSize="small"
        messageTypographyStyle={{
          font: "normal normal bold 20px/28px Mulish",
          display: "flex",
          justifyContent: "flex-start",
        }}
        bodyTypographyStyle={{
          font: "normal normal  18px/28px Mulish",
          display: "flex",
          justifyContent: "flex-start",
        }}
        playAnimation={false}
        buttonStyles={{ display: "flex", justifyContent: "flex-end" }}
      />

      <CssBaseline />

      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          display: "none",
        }}
      ></AppBar>
      <Box
        component="nav"
        className="sideNavWidth"
        sx={{
          width: { sm: drawerWidth },
          flexShrink: { sm: 0 },
        }}
        aria-label="mailbox folders"
      >
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          onClick={handleDrawerToggle}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
    </div>
  );
};

export default Sidenav;
